// Module
var code = "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path id=\"Icon_material-add-circle\" data-name=\"Icon material-add-circle\" d=\"M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm6,13.2H13.2V18H10.8V13.2H6V10.8h4.8V6h2.4v4.8H18Z\" transform=\"translate(0)\"/></svg>";
// Exports
module.exports = code;